import API from '../../services/api.svelte.js';
import { notificate } from '../../services/notification.js';


function filterIsEmpy(filter){
    for (let prop in filter) {
        if (filter.hasOwnProperty(prop)) {
            return false;
        }
    }
    return true;
}

export async function search(){
    return API.get("v2/snapshots", {});
}

export async function save(ephemeral = true){
    return API.save("v2/snapshots", {ephemeral: ephemeral}, [], {}, true )
    .catch(() => {
            return false;
        })
        .then(async response => {
            if (!response.ok) {
                let errors = await response.json();
                throw new Error(errors);
            }
            else {
                return response.json();
            }
        })
        .then(apiData => {
            //returns saved element to update table
            return apiData;
        })
    ;
}

export async function find(id, config = {}) {
    let snapshot;
    return API.find('v2/snapshots', id, config)
        .catch(() => {
            return false;
        })
        .then(pSnapshot => {
            snapshot = pSnapshot;
            return snapshot;
        })
    ;
}


export async function getReport(config = {filter: {}}, summary_id, snapshot_id) {

    let filter_query_string = '';
    if(!filterIsEmpy(config.filter)){
        Object.keys(config.filter).forEach((k)=>{
            filter_query_string = filter_query_string + (filter_query_string == '' ? "?" : '&') +  k + "=" + config.filter[k];
        });
    }
    if(!summary_id){
        return API.getFile(`v2/snapshots/${snapshot_id}/report` + filter_query_string);
    }
    else {
        return API.getFile(`v2/snapshots/${snapshot_id}/report` + (filter_query_string.length > 0 ? filter_query_string + '&summary_id=' + summary_id : '?summary_id=' + summary_id));
    }

}

export async function getComparisonReport(base_snapshot_id, comparison_snapshot_id, lang) {
    return API.getFile(`v2/snapshots/${base_snapshot_id}/report/${comparison_snapshot_id}?language=${lang}`);
}


export async function saveReport(config, summary_id, snapshot_id){
    let filter_query_string = '';
    if(!filterIsEmpy(config.filter)){
        Object.keys(config.filter).forEach((k)=>{
            filter_query_string = filter_query_string + (filter_query_string == '' ? "?" : '&') +  k + "=" + config.filter[k];
        });
    }
    if(!summary_id){
        return await API.saveFile(`v2/snapshots/${snapshot_id}/report` + filter_query_string);
    }
    else {
        return API.saveFile(`v2/snapshots/${snapshot_id}/report` + (filter_query_string.length > 0 ? filter_query_string + '&summary_id=' + summary_id : '?summary_id=' + summary_id));
    }
}

export function downloadSavedReport(id){
    return API.getFile(`v2/report/${id}/content`)
}



export default {
    search,
    save,
    find,
    getReport,
    saveReport,
    downloadSavedReport,
    getComparisonReport
}